import { useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import useLoadSpeakers from '@/connection/hooks/use-load-speakers';
import { getWorkingProject } from '@/store/slices/project/selectors';
import { Speaker } from '@/types/speakers.types';
import CastAndCrewSelect from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/cast-and-crew/cast-and-crew-select';
import { memo } from 'react';

type EditableCastAndCrewProps = {
  defaultSpeakers?: { label: string; value: number; meta?: Speaker }[];
  onMenuClose: (selectedSpeakers: { label: string; value: number; meta?: Speaker }[]) => void;
  disabled?: boolean;
  /**
   * only add the speakers prop for controlled components - "add new session modal".
   * Otherwise the speakers are auto pulled in via the session modules inside of displat cast and crew
   * */
  speakers?: Speaker[];
};

const EditableCastAndCrew = memo(
  ({ defaultSpeakers = [], disabled, onMenuClose, speakers }: EditableCastAndCrewProps) => {
    useLoadSpeakers();

    const channel = useAppSelector(getActiveChannel);
    const workingProject = useAppSelector(getWorkingProject);

    if (!channel || !workingProject) return null;
    return (
      <div>
        <CastAndCrewSelect
          defaultSpeakers={defaultSpeakers}
          speakers={speakers?.map((s) => ({
            label: `${s.first_name} ${s.last_name}`.trim(),
            value: s.speaker,
            meta: s,
          }))}
          onMenuClose={onMenuClose}
          disabled={disabled}
        />
      </div>
    );
  }
);

export default EditableCastAndCrew;
